import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=11d94130&scoped=true&"
import script from "./Goal.vue?vue&type=script&lang=ts&"
export * from "./Goal.vue?vue&type=script&lang=ts&"
import style0 from "./Goal.vue?vue&type=style&index=0&id=11d94130&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d94130",
  null
  
)

export default component.exports